export class ContextInfoUser {

  public usersBrokerName: string;
  public usersBrokerFaced: string;
  public usersBrokerService: string;
  public usersBrokerImamge: string;
  public usersBrokerViewName: string;

}
